var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4227 6.4478L10.5066 6.90049L10.8406 6.58358L14.5146 3.09729L12.3343 7.66884L12.1361 8.0844L12.5926 8.02432L17.6141 7.3634L13.1631 9.7803L12.7585 10L13.1631 10.2197L17.6141 12.6366L12.5926 11.9757L12.1361 11.9156L12.3343 12.3312L14.5146 16.9027L10.8406 13.4164L10.5066 13.0995L10.4227 13.5522L9.49951 18.5322L8.57634 13.5522L8.49242 13.0995L8.15844 13.4164L4.4844 16.9027L6.66472 12.3312L6.86291 11.9156L6.40644 11.9757L1.38489 12.6366L5.83589 10.2197L6.24049 10L5.83589 9.7803L1.38489 7.3634L6.40644 8.02432L6.86291 8.0844L6.66472 7.66884L4.4844 3.09729L8.15844 6.58358L8.49242 6.90049L8.57634 6.4478L9.49951 1.46778L10.4227 6.4478Z",
    stroke: "#FB06BB",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.f8d9a9e07a044227191d62d76d86515d.svg";
export { ForwardRef as ReactComponent };